import { Icon, Text, View } from ".."
import { Metrics, Helpers, Colors } from '../../global'
import { useNavigate } from "react-router-dom"
import { Menu, ConfigProvider } from "antd"
import { ReactComponent as optionsIcon } from '../../Assets/SVG/Options.svg'
import { React } from 'react'

const sensorReadingColumns = (graphData, allSites, expandedSensor, currentStore) => [
    {
        title: 'Time',
        sorter: (a, b) => a?.x - b?.x,
        defaultSortOrder: 'descend',
        align: 'center',
        render: (_, a) => {
            return (
                <View style={Helpers.textCenter}>
                    <Text as="md" weight="regular" color={'textPrimary'}>
                        {new Date(a.x).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true })}
                    </Text>
                </View>
            )
        },
    },
    {
        title: 'Temperature',
        sorter: (a, b) => a?.y - b?.y,
        align: 'center',
        render: (_, a) => {
            if (graphData.convertedData.length == 0) return <></>
            let dataIndex = graphData.convertedData.findIndex((x) => new Date(x[0] * 1000).getTime() === a.x.getTime())
            return (
              <View style={Helpers.textCenter}>
                <Text as="md" weight="regular" color={"textPrimary"}>
                  {graphData.convertedData[dataIndex][1].toFixed(2) +
                    " " +
                    allSites[expandedSensor[0]]?.settings?.channels
                      ?.sthp_temp?.unit}
                </Text>
              </View>
            );
        },
    }
]


export default sensorReadingColumns